import { render, staticRenderFns } from "./es-faq.vue?vue&type=template&id=4efedc1c&"
import script from "./es-faq.vue?vue&type=script&lang=js&"
export * from "./es-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports